export const toReportApi = (apiObj) => {
    const responseData = apiObj
    return {
        email: responseData.raportEmail,
        description: responseData.raportContent
    }
}

export default toReportApi
